// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
// 引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
import {
  post,
  get
} from './http'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'
import Carousel3d from "vue-carousel-3d"
import wxApi from './wx'
Vue.prototype.wxApi = wxApi
Vue.use(Carousel3d)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
//定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.config.productionTip = false;
Vue.prototype.$http =axios;
Vue.use(Vant)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js